import { render, staticRenderFns } from "./GridOfCard.vue?vue&type=template&id=f66329c6&scoped=true&"
import script from "./GridOfCard.vue?vue&type=script&lang=js&"
export * from "./GridOfCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66329c6",
  null
  
)

export default component.exports